<template>
  <div class="leaderboard__wrapper my-4">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="320" height="50">
      <v-card-text class="text-center text-overline accent--text">MOBILE LEADERBOARD 320 x 50</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MobileLeaderboard'
  }
</script>